import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FiUsers, FiUserCheck, FiCreditCard, FiDollarSign, FiHelpCircle, FiAlertCircle, FiArrowRight } from 'react-icons/fi';
import { fetchDashboardStats } from '../../store/slices/dashboardSlice';
import { Loading } from '../../components/Common';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { stats, recentUsers, isLoading } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(fetchDashboardStats());
  }, [dispatch]);

  if (isLoading) {
    return <Loading />;
  }

  const statCards = [
    {
      title: 'Total Users',
      value: stats.totalUsers || 0,
      icon: FiUsers,
      color: 'purple',
      link: '/users',
    },
    {
      title: 'Active Users',
      value: stats.activeUsers || 0,
      icon: FiUserCheck,
      color: 'green',
      link: '/users',
    },
    {
      title: 'Verified Profiles',
      value: stats.verifiedProfiles || 0,
      icon: FiUserCheck,
      color: 'blue',
      link: '/users',
    },
    {
      title: 'Active Subscriptions',
      value: stats.activeSubscriptions || 0,
      icon: FiCreditCard,
      color: 'orange',
      link: '/subscriptions',
    },
    {
      title: 'Total Revenue',
      value: `$${stats.totalRevenue || 0}`,
      icon: FiDollarSign,
      color: 'green',
      link: '/subscriptions',
    },
    {
      title: 'Open Tickets',
      value: stats.openTickets || 0,
      icon: FiAlertCircle,
      color: 'red',
      link: '/help-support',
    },
  ];

  return (
    <div>
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <Link to={stat.link} key={index} style={{ textDecoration: 'none' }}>
            <div className="stat-card">
              <div className={`stat-icon ${stat.color}`}>
                <stat.icon />
              </div>
              <div className="stat-content">
                <h3>{stat.value}</h3>
                <p>{stat.title}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Recent Users</h3>
          <Link to="/users" className="btn btn-secondary btn-sm">
            View All <FiArrowRight style={{ marginLeft: '4px' }} />
          </Link>
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          {recentUsers && recentUsers.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Mobile</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {recentUsers.slice(0, 5).map((user) => (
                  <tr key={user._id}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {user.photos && user.photos[0] ? (
                          <img
                            src={user.photos[0]}
                            alt={user.fullName || user.mobile}
                            className="table-image"
                            style={{ borderRadius: '50%' }}
                          />
                        ) : (
                          <div
                            className="table-image"
                            style={{
                              background: '#e5e7eb',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '50%',
                            }}
                          >
                            <FiUsers />
                          </div>
                        )}
                        <span>{user.fullName || 'N/A'}</span>
                      </div>
                    </td>
                    <td>{user.mobile || '-'}</td>
                    <td style={{ textTransform: 'capitalize' }}>{user.gender || '-'}</td>
                    <td>{user.age || '-'}</td>
                    <td>
                      <span className={`badge ${user.isActive ? 'badge-success' : 'badge-danger'}`}>
                        {user.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
              No users found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
